export enum Manufacturer {
  UNKNOWN = 'unknown',
  SAMSUNG = 'samsung',
  VIZIO = 'vizio',
  LG = 'lg',
  COMCAST = 'comcast',
}
